"use client"

import { useCallback, useEffect, useState } from "react"
import { useTheme } from "styled-components"

import { useWindowSize } from "./useWindowSize"

/**
 * Controlls if message should be shown or not
 *
 * @returns [showWarning: boolean, dismiss: function]
 */
const useShowMessage = () => {
  const { screen } = useTheme()
  const { minWidth, minHeight } = screen
  // set the state. One indicating if warning should be shown
  const [showWarning, setShowWarning] = useState(false)
  // second for indicating if it was dismissed (message should not be show on resize)
  const [wasDismissed, setWasDismissed] = useState(false)
  const windowSize = useWindowSize()

  useEffect(() => {
    const { width, height } = windowSize

    // check if it was not dismissed and if dimensions pass minimum dimensions
    if (!wasDismissed && (width < minWidth || height < minHeight)) {
      setShowWarning(true)
    } else {
      setShowWarning(false)
    }
  }, [windowSize, wasDismissed, minWidth, minHeight])

  // if dismiss was triggered, set both to false
  const dismiss = useCallback(() => {
    setWasDismissed(true)
    setShowWarning(false)
  }, [])

  return [showWarning, dismiss]
}

export { useShowMessage }
